import { Link, type ItemType } from "@/atoms"
import { Permission } from "@/domain/user"
import { ExternalLinkMenuItem } from "@/molecules/ExternalLinkMenuItem"
import { filterItems, getItems } from "@/pages/SettingsPage/helpers/menu"

import styles from "./MenuHeader.module.scss"

import type { TFunction } from "@/hooks/useTranslation"

export const getNavMenu = (
  currentKey: string,
  {
    hasPermission,
    t
  }: {
    hasPermission: (permission: Permission) => boolean | undefined
    t: TFunction
  }
) => {
  const PREFIX_URL = "/settings"
  const defaultItems = getItems(t)
  let isActive = false

  const itemsWithClassName = filterItems(defaultItems, hasPermission).map(
    (item, index) => {
      const { label, key, externalLink } = item

      if (externalLink)
        return {
          key,
          label: <ExternalLinkMenuItem href={externalLink} text={label} />
        }

      if (key) {
        const to = `${PREFIX_URL}/${key}`
        const isMatch = currentKey === to
        const className = isMatch ? styles.active : ""

        if (isMatch) isActive = true

        return {
          key,
          className,
          label: <Link to={to}>{label}</Link>
        }
      }

      return { label, key: index, disabled: true }
    }
  ) as ItemType[]

  return { isActive, items: itemsWithClassName }
}
